import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    this._initListHeads()
    this._restoreFromHash()
  }

  _initListHeads() {
    this.element.querySelectorAll(
      "ol > li > h1:first-child, ol > li > h2:first-child, ol > li > h3:first-child, ol > li > h4:first-child, ol > li > h5:first-child, ol > li > h6:first-child"
    ).forEach(headEl => {
      let id = this._hashIdFromHead(headEl.textContent)
      // NOTE head > li > ol > li, i.e. the enclosing item - the top level has none
      let parentLiEl = headEl.parentElement.parentElement.parentElement
      if (parentLiEl && parentLiEl.matches("li")) {
        let parentAnchorEl = parentLiEl.querySelector(":scope > *:first-child > a:first-child")
        if (parentAnchorEl) {
          id = parentAnchorEl.id + "--" + id
        }
      }
      let anchorEl = this._insertLink(headEl, id, "#" + id)
      anchorEl.addEventListener("click", (e) => this._toggleExpand(e, anchorEl))
    })
  }

  _restoreFromHash(e) {
    let id = location.hash.substr(1)
    let el = document.getElementById(id)
    if (!el) {
      return
    }
    el = el.parentElement.parentElement
    while (el && el != this.element) {
      if (el.matches("ol > li")) {
        el.classList.add("expanded")
      }
      el = el.parentElement
    }
    // NOTE the browser scrolled to the hash before we expanded the ancestors above it
    requestAnimationFrame(() => document.getElementById(id).scrollIntoView({block: "start"}))
  }

  _insertLink(el, id, href) {
    const anchorEl = document.createElement("a")
    anchorEl.id = id
    anchorEl.href = href
    anchorEl.textContent = el.textContent
    anchorEl.setAttribute("data-turbo", "false")
    el.textContent = ""
    el.prepend(anchorEl)
    return anchorEl
  }

  // TODO aigenned, mostly
  _hashIdFromHead(text) {
    const hash = (s) => {
      let h = 0
      for (let i = 0; i < s.length; i++)
        h = ((h << 5) - h) + s.charCodeAt(i) | 0
      return Math.abs(h).toString(36)
    }

    return text
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .split("-")
      .filter(s => s.length >= 3)
      .slice(0, 4)
      .concat(hash(text))
      .map(s => s.slice(0, 4))
      .join("-")
  }

  _toggleExpand(e, anchorEl) {
    let parentLiEl = anchorEl.parentElement.parentElement.parentElement.parentElement
    let parentAnchorEl
    if (parentLiEl) {
      parentAnchorEl = parentLiEl.querySelector(":scope > *:first-child > a:first-child")
    }
    if (anchorEl.parentElement.parentElement.matches(".expanded")) {
      e.preventDefault()
      if (parentAnchorEl) {
        location.hash = "#" + parentAnchorEl.id
      }
    }
    anchorEl.parentElement.parentElement.classList.toggle("expanded")
  }
}
